import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { PapiDeviation } from '@wix/da-papi-types';
import StatItem from '../../StudioDeviationList/_partials/StatItem';
import { OriginalsData } from '../../../types/store';

import s from './OriginalStatsMobile.scss';

interface Props {
  deviation: PapiDeviation;
  originalsData?: OriginalsData;
}

const OriginalStatsMobile: FC<Props> = ({ deviation, originalsData }) => {
  const { t } = useTranslation();

  const originals = deviation.originals;

  const pendingCount = originalsData?.pendingOrdersCount ?? 0;
  const inProgressCount = originals?.inProgressOrdersCount ?? 0;
  const completedCount = originals?.completedOrdersCount ?? 0;

  return (
    <div className={s['root']}>
      <StatItem
        title={t('studio.products.original.stats.pendingRequest')}
        value={pendingCount}
      />
      <StatItem
        title={t('studio.products.original.stats.inProgress')}
        value={inProgressCount}
      />
      <StatItem
        title={t('studio.products.original.stats.completed')}
        value={completedCount}
      />
    </div>
  );
};
OriginalStatsMobile.displayName = 'OriginalStatsMobile';

export default OriginalStatsMobile;
